import { render, staticRenderFns } from "./firmSelfhelp.vue?vue&type=template&id=f1c2fa06"
import script from "./firmSelfhelp.vue?vue&type=script&lang=js"
export * from "./firmSelfhelp.vue?vue&type=script&lang=js"
import style0 from "./firmSelfhelp.vue?vue&type=style&index=0&id=f1c2fa06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports